import type { JSX } from 'react';
import { Text } from '@chakra-ui/react';

export const NabanCardListItemTitle = ({ title }: { title: string | JSX.Element }) => (
  <Text
    as={typeof title === 'string' ? 'span' : 'div'}
    variant='tableCell'
    fontSize={18}
    color='neutral600'
    overflow='hidden'>
    {title}
  </Text>
);
